/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

export interface CalendarState {
	id: number
	title: string
}

export const defaultCalendar: CalendarState = {
	id: 0,
	title: "My Team",
};

const STORAGE_KEY = 'vega.state.calendar';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: CalendarState = storedState ? JSON.parse(storedState) : defaultCalendar;

export const slice = createSlice({
	name: 'calendar',
	initialState,
	reducers: {
		set: (state, action: PayloadAction<CalendarState>) => {
			const newState = action.payload;
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const { set } = slice.actions;
export default slice.reducer;